<<!-- 添加单品 -->
<template>
  <div class="4 default">
    <el-row class="text-l">
      <el-col :span="24" class="line-22 mt-24 mb-20">
        <span class="fz-14 c-000 mr-10">提报明细</span>
        <span class="fz-14 c-606">优惠信息提报后，平台将于24小时内完成审核。</span>
      </el-col>
    </el-row>

    <!-- 搜索 -->
    <el-row>
      <!-- <el-row class="mb-20"> -->
      <el-form class="inline" label-position="right" label-width="90px" size='large' :inline="true">
        <el-form-item label="推广短标题">
          <el-input clearable v-model.trim="goods_title" class="w-220"></el-input>
        </el-form-item>
        <el-form-item label="商品ID">
          <el-input clearable v-model.trim="other_platform_gsid" class="w-220"></el-input>
        </el-form-item>
        <el-form-item label="提交日期">
          <el-date-picker
            @change="getSubtime(1)"
            style="width:220px"
            :default-time="['00:00:00', '23:59:59']"
            v-model="create_time"
            :editable="false"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="发布日期">
          <el-date-picker
            @change="getSubtime(2)"
            style="width:220px"
            :default-time="['00:00:00', '23:59:59']"
            v-model="check_audit_time"
            :editable="false"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          ></el-date-picker>
        </el-form-item>
      </el-form>
      <el-form label-position="right" label-width="90px">
       <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="searchSome">搜索</el-button>
          <el-button @click="setClear">重置</el-button>
        </el-form-item>
      </el-form>

      <!-- <div class="w-284 line-32 fz-14 c-606 fl">
          <span class="fl w-78">推广短标题</span>
          
      </div>-->
      <!-- <div class="w-284 line-32 fz-14 c-606 fl">
          <span class="fl w-63 text-r pr-15">商品ID</span>
          
      </div>-->
      <!-- <div class="w-284 line-32 fz-14 c-606 fl">
          <span class="fl w-63 text-r pr-15">提交日期</span>
          <el-date-picker
            value-format="yyyy-MM-dd 00:00:00"
            v-model="create_time_s"
            type="date"
            placeholder="选择提交开始日期"
            class="fl"
            style="width:191px;"
          ></el-date-picker>
        </div>
        <div class="w-228 line-32 fz-14 c-606 fl">
          <span class="fl w-26">至</span>
          <el-date-picker
            style="width:191px;"
            value-format="yyyy-MM-dd 23:59:59"
            v-model="create_time_e"
            type="date"
            placeholder="选择提交结束日期"
            class="fl"
          ></el-date-picker>
      </div>-->
      <!-- </el-row> -->
      <!-- <el-row class="mb-30 min-w1096">
        <div class="w-284 line-32 fz-14 c-606 fl">
          <span class="fl w-78">发布日期</span>
          <el-date-picker
            style="width:191px;"
            value-format="yyyy-MM-dd 00:00:00"
            v-model="check_audit_time_s"
            type="date"
            placeholder="选择发布开始日期"
            class="fl"
          ></el-date-picker>
        </div>
        <div class="w-228 line-32 fz-14 c-606 fl">
          <span class="fl w-26">至</span>
          <el-date-picker
            style="width:191px;"
            value-format="yyyy-MM-dd 23:59:59"
            v-model="check_audit_time_e"
            type="date"
            placeholder="选择发布结束日期"
            class="fl"
          ></el-date-picker>
        </div>
        <div class="fl">
          <el-button type="primary" icon="el-icon-search" @click="searchSome">搜索</el-button>
          <el-button @click="setClear">重置</el-button>
        </div>
      </el-row>-->
      <!-- 列表 -->
      <el-row>
        <el-tabs
          type="card"
          v-model="status_tab"
          @tab-click="handleClick"
          class="c-606"
          style="color:red;"
        >
          <el-tab-pane
            class="c-606"
            v-for="(item,index) in status"
            :key="index"
            :label="item.name+'('+item.num+')'"
            :name="item.status_id"
          ></el-tab-pane>
        </el-tabs>
      </el-row>
      <!-- tab -->
      <el-row>
        <el-table :data="list" style="width:100%;">
          <el-table-column label="商品" width="230" inline>
            <template slot-scope="scope">
              <div @click="goConpon(scope.row.goods_out_url)">
                <img :src="scope.row.goods_img" class="goods-img fl pointer">
                <div class="w-130 fl ml-10">
                  <div class="line-20 min-h40 line-title">{{scope.row.short_extension_title}}</div>
                  <div class="block line-14 mt-13">商品ID:{{scope.row.other_platform_gsid}}</div>
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop label="价格">
            <template slot-scope="scope">
              <div>{{scope.row.real_money}}元</div>
              <div>{{scope.row.is_postage==1?"包邮":"不包邮"}}</div>
            </template>
          </el-table-column>
          <el-table-column prop label="佣金">
            <template slot-scope="scope">
              <div class="c-9da">{{scope.row.commission}}元</div>
              <div>{{scope.row.commission_rate}}%</div>
            </template>
          </el-table-column>
          <el-table-column prop label="优惠券" width="140">
            <template slot-scope="scope">
              <div v-if="scope.row.is_have_coupon">
                <div
                  class="youhuiquan c-fff fz-10 center pointer"
                  @click="goConpon(scope.row.coupon_url)"
                >¥{{scope.row.coupon_money}}</div>
                <span>
                  已领
                  <span class="c-ea4">{{scope.row.coupon_num_total-scope.row.coupon_num_suplus}}</span>
                  /{{scope.row.coupon_num_total}}
                </span>
              </div>
              <div v-else>- -</div>
            </template>
          </el-table-column>
          <el-table-column prop label="优惠生效时间">
            <template slot-scope="scope">
              <div v-if="scope.row.is_have_coupon">
                <div>{{scope.row.coupon_start_time}}</div>
                <div class="center">至</div>
                <div>{{scope.row.coupon_end_time}}</div>
              </div>
              <div v-else>- -</div>
            </template>
          </el-table-column>
          <el-table-column prop label="状态">
            <template slot-scope="scope">
              <div v-if="scope.row.status==0" class="fl c-f0a">待审核</div>
              <div v-if="scope.row.status==1" class="fl c-e53">已拒绝</div>
              <div v-if="scope.row.status==2" class="fl">进行中</div>
              <div v-if="scope.row.status==3" class="fl">未开始</div>
              <div v-if="scope.row.status==4" class="fl c-999">已下架</div>
              <el-tooltip :content="scope.row.reason" v-if="scope.row.status==1" placement="top">
                <i class="el-icon-warning fl ml-4 mt-4 pointer fz-15 c-e53"></i>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column prop label="备注">
            <template slot-scope="scope">
              <el-tooltip placement="top" class="pointer">
                <slot v-if="scope.row.remark">
                  <div slot="content" style="width:240px;line-heihgt:22px;">{{scope.row.remark}}</div>
                </slot>
                <span class="hover-9da" v-if="scope.row.remarks">{{scope.row.remarks}}</span>
              </el-tooltip>
              <span v-if="!scope.row.remark">--</span>
            </template>
          </el-table-column>
          <el-table-column prop label="操作" width='100px'>
            <template slot-scope="scope">
              <el-button
                class="mb-10 mt-10"
                sizi="mini"
                v-if="scope.row.status!=1"
                @click="goDetail(scope.row.aeid)"
              >查看详情</el-button>
              <el-button
                sizi="mini"
                v-if="scope.row.status==2&&(scope.row.coupon_status==2||scope.row.coupon_status==3)"
                @click="setXiajia(scope.row.aeid)"
              >下架</el-button>
              <el-button sizi="mini" v-if="scope.row.status==1" @click="editSome(scope.row.aeid)">修改</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-row>

      <!-- 页码 -->
      <el-row v-if="count">
        <el-col :span="24" class="flex-bw flex-al line-20 mt-20">
          <div class="fz-13">
            <span>第</span>
            <span class="ml-4 mr-4">{{offset}}</span>
            <span>页</span>
          </div>
          <div>
            <div class="block">
              <el-pagination
                @size-change="handleSizeChange"
                @current-change="getData"
                :current-page.sync="offset"
                :page-size="limit"
                :page-sizes="[10, 20, 30, 40]"
                layout="total,sizes,prev, pager, next, jumper"
                :total="count"
              ></el-pagination>
            </div>
          </div>
        </el-col>
      </el-row>
      <!-- 下架 -->
      <el-dialog title="提示" :visible.sync="xiajia" width="30%">
        <span>该商品已审核通过，确认下架该商品？</span>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="sureXiajia">确认</el-button>
          <el-button @click="xiajia=false">取消</el-button>
        </span>
      </el-dialog>
    </el-row>
  </div>
</template>

<script>
import "./tool.css";
import utils from "../../utils/util.js";
export default {
  name: "subsomeone",
  data() {
    return {
      api: {
        getUserArticleList: "/home/getUserArticleList", //我的提报单品列表
        getUserArticleSoldOut: "/home/getUserArticleSoldOut" //下架某个商品
      },
      status_tab: "1", //列表的默认选中状态
      vip_status_tab: "1", //vip列表默认选中
      // gsid: "", //商品id
      goods_title: "", //商品标题
      create_time: "", //提交时间
      check_audit_time: "", //发布时间
      create_time_s: "", //提交日期开始
      create_time_e: "", //提交日期结束
      check_audit_time_s: "", //发布日期 - start 审核通过的日期
      check_audit_time_e: "", //发布日期 - end 审核通过的日期
      check_status_start: "1", //审核状态 -- 进行中 选中那个状态对应的就添写 1，其他则都为0
      check_status_not_start: "", //未开始
      check_status_wait: "", //待审核
      check_status_refuse: "", //已拒绝
      check_status_end: "", //已经下架
      offset: 1, //当前页
      limit: 10, //每页的条数
      count: 0, //总的条数
      list: [], //列表返回的数据
      xiajia: false, //审核下架
      aeid: "", //下架商品id
      other_platform_gsid: "", //淘系商品id
      status: [
        {
          name: "进行中",
          num: "",
          status_id: "1"
        },
        {
          name: "未开始",
          num: "",
          status_id: "2"
        },
        {
          name: "待审核",
          num: "",
          status_id: "3"
        },
        {
          name: "已拒绝",
          num: "",
          status_id: "4"
        },
        {
          name: "已下架",
          num: "",
          status_id: "5"
        },
        {
          name: "全部",
          num: "",
          status_id: "6"
        }
      ]
    };
  },
  components: {},
  created() {
    //招商提报还是普通用户提报
    if (this.$route.params.type) {
      let status = JSON.parse(sessionStorage.getItem("x_status"));
      this.other_platform_gsid = status.other_platform_gsid; //商品id
      this.goods_title = status.goods_title; //商品标题
      this.create_time_s = status.create_time_s; //提交日期开始
      this.create_time_e = status.create_time_e; //提交日期结束
      this.check_audit_time_s = status.check_audit_time_s; //发布日期 - start 审核通过的日期
      this.check_audit_time_e = status.check_audit_time_e; //发布日期 - end 审核通过的日期
      this.check_status_start = status.check_status_start; //审核状态 -- 进行中 选中那个状态对应的就添写 1，其他则都为0
      this.check_status_not_start = status.check_status_not_start; //未开始
      this.check_status_wait = status.check_status_wait; //待审核
      this.check_status_refuse = status.check_status_refuse; //已拒绝
      this.check_status_end = status.check_status_end; //已经下架
      this.offset = status.offset;
      this.limit = status.limit;
      this.status_tab = status.status_tab;
      this.createList();
    } else {
      this.createList();
    }
  },
  mounted() {},
  methods: {
    createList() {
      let _this = this;
      this.$http({
        method: "POST",
        url: _this.api.getUserArticleList,
        data: {
          other_platform_gsid: _this.other_platform_gsid, //商品id
          goods_title: _this.goods_title, //商品标题
          create_time_s: _this.create_time_s, //提交日期开始
          create_time_e: _this.create_time_e, //提交日期结束
          check_audit_time_s: _this.check_audit_time_s, //发布日期 - start 审核通过的日期
          check_audit_time_e: _this.check_audit_time_e, //发布日期 - end 审核通过的日期
          check_status_start: _this.check_status_start, //审核状态 -- 进行中 选中那个状态对应的就添写 1，其他则都为0
          check_status_not_start: _this.check_status_not_start, //未开始
          check_status_wait: _this.check_status_wait, //待审核
          check_status_refuse: _this.check_status_refuse, //已拒绝
          check_status_end: _this.check_status_end, //已经下架
          offset: _this.offset,
          limit: _this.limit
        }
      }).then(res => {
        if (res.code == 1) {
          this.list = res.data.list;
          this.list.forEach((item, index) => {
            if (item.remark.length >= 12) {
              item.remarks = item.remark.slice(0, 12) + "...";
            } else {
              item.remarks = item.remark;
            }
          });
          // return false;
          this.count = res.data.count;
          this.status.forEach((item, index) => {
            if (item.status_id == 1) {
              item.num = res.data.status_count.check_status_start;
            } else if (item.status_id == 2) {
              item.num = res.data.status_count.check_status_not_start;
            } else if (item.status_id == 3) {
              item.num = res.data.status_count.check_status_wait;
            } else if (item.status_id == 4) {
              item.num = res.data.status_count.check_status_refuse;
            } else if (item.status_id == 5) {
              item.num = res.data.status_count.check_status_end;
            } else if (item.status_id == 6) {
              item.num = res.data.status_count.check_status_all;
            }
          });
        } else {
          _this.$message({
            message: res.msg,
            type: "warning"
          });
        }
      });
    },
    //去到领券页面
    goConpon(path) {
      console.log(1);
      window.open(path);
    },
    //下架某个商品
    setXiajia(aeid) {
      this.xiajia = true;
      this.aeid = aeid;
    },
    //确定下架信息
    sureXiajia() {
      let _this = this;
      this.$http({
        method: "POST",
        url: _this.api.getUserArticleSoldOut,
        data: {
          aeid: _this.aeid
        }
      }).then(res => {
        if (res.code == 1) {
          _this.$message({
            message: "下架成功",
            type: "success"
          });
          _this.xiajia = false;
          _this.createList();
        } else {
          _this.$message({
            message: res.data,
            type: "warning"
          });
        }
      });
    },
    //查找某个商品
    searchSome() {
      let a = this.compTime(this.create_time_s, this.create_time_e, 1);
      let b = this.compTime(
        this.check_audit_time_s,
        this.check_audit_time_e,
        2
      );
      if (a != "") {
        return false;
      } else if (b != "") {
        return false;
      }
      this.offset = 1;
      this.status_tab = "6";
      this.check_status_start = ""; //审核状态 -- 进行中 选中那个状态对应的就添写 1，其他则都为0
      this.check_status_not_start = ""; //未开始
      this.check_status_wait = ""; //待审核
      this.check_status_refuse = ""; //已拒绝
      this.check_status_end = ""; //已经下架
      this.createList();
    },
    //电击tab切换状态的时候
    handleClick(tab, event) {
      let status = tab.name;
      this.offset = 1;
      if (status == 1) {
        this.check_status_start = 1;
        this.check_status_not_start = ""; //未开始
        this.check_status_wait = ""; //待审核
        this.check_status_refuse = ""; //已拒绝
        this.check_status_end = ""; //已经下架
        this.createList();
      } else if (status == 2) {
        this.check_status_start = "";
        this.check_status_not_start = 1; //未开始
        this.check_status_wait = ""; //待审核
        this.check_status_refuse = ""; //已拒绝
        this.check_status_end = ""; //已经下架
        this.createList();
      } else if (status == 3) {
        this.check_status_start = "";
        this.check_status_not_start = ""; //未开始
        this.check_status_wait = 1; //待审核
        this.check_status_refuse = ""; //已拒绝
        this.check_status_end = ""; //已经下架
        this.createList();
      } else if (status == 4) {
        this.check_status_start = "";
        this.check_status_not_start = ""; //未开始
        this.check_status_wait = ""; //待审核
        this.check_status_refuse = 1; //已拒绝
        this.check_status_end = ""; //已经下架
        this.createList();
      } else if (status == 5) {
        this.check_status_start = "";
        this.check_status_not_start = ""; //未开始
        this.check_status_wait = ""; //待审核
        this.check_status_refuse = ""; //已拒绝
        this.check_status_end = 1; //已经下架
        this.createList();
      } else if (status == 6) {
        this.check_status_start = "";
        this.check_status_not_start = ""; //未开始
        this.check_status_wait = ""; //待审核
        this.check_status_refuse = ""; //已拒绝
        this.check_status_end = ""; //已经下架
        this.createList();
      }
    },
    //清空搜索条件
    setClear() {
      this.other_platform_gsid = "";
      this.goods_title = "";

      this.create_time = ""; //提交日期开始
      // this.create_time_e = ""; //提交日期结束
      this.check_audit_time = ""; //发布日期 - start 审核通过的日期
      // this.check_audit_time_e = ""; //发布日期 - end 审核通过的日期
    },
    //改变页数
    handleSizeChange(val) {
      this.limit = val;
      this.offset = 1;
      this.createList();
    },
    //指定页码
    getData(val) {
      this.offset = val;
      this.createList();
    },
    //去到查看详情页面
    goDetail(aeid) {
      // status_tab
      let status = {
        status_tab: this.status_tab, //列表状态
        offset: this.offset, //当前页
        limit: this.limit, //每页条数
        other_platform_gsid: this.other_platform_gsid, //商品id
        goods_title: this.goods_title, //商品标题
        create_time_s: this.create_time_s, //提交日期开始
        create_time_e: this.create_time_e, //提交日期结束
        check_audit_time_s: this.check_audit_time_s, //发布日期 - start 审核通过的日期
        check_audit_time_e: this.check_audit_time_e, //发布日期 - end 审核通过的日期
        check_status_start: this.check_status_start, //审核状态 -- 进行中 选中那个状态对应的就添写 1，其他则都为0
        check_status_not_start: this.check_status_not_start, //未开始
        check_status_wait: this.check_status_wait, //待审核
        check_status_refuse: this.check_status_refuse, //已拒绝
        check_status_end: this.check_status_end //已经下架
      };
      sessionStorage.setItem("x_status", JSON.stringify(status));
      this.$router.push({
        name: "detail",
        query: {
          aeid: aeid
        }
      });
    },
    //去到修改单品页面
    editSome(aeid) {
      //修改全局状态
      let status = {
        status_tab: this.status_tab, //列表状态
        offset: this.offset, //当前页
        limit: this.limit, //每页条数
        other_platform_gsid: this.other_platform_gsid, //商品id
        goods_title: this.goods_title, //商品标题
        create_time_s: this.create_time_s, //提交日期开始
        create_time_e: this.create_time_e, //提交日期结束
        check_audit_time_s: this.check_audit_time_s, //发布日期 - start 审核通过的日期
        check_audit_time_e: this.check_audit_time_e, //发布日期 - end 审核通过的日期
        check_status_start: this.check_status_start, //审核状态 -- 进行中 选中那个状态对应的就添写 1，其他则都为0
        check_status_not_start: this.check_status_not_start, //未开始
        check_status_wait: this.check_status_wait, //待审核
        check_status_refuse: this.check_status_refuse, //已拒绝
        check_status_end: this.check_status_end //已经下架
      };
      sessionStorage.setItem("x_status", JSON.stringify(status));
      // sessionStorage.setItem("setType", 2);
      // this.$store.dispatch("setType", 2);
      this.$router.push({
        name: "subsomeone",
        query: {
          aeid: aeid,
          type: 2
        }
      });
    },
    getSubtime(num) {
      //选择时间
      if (num == 1) {
        this.create_time_s = utils.dateFormat(
          new Date(this.create_time[0])
        ).full;
        this.create_time_e = utils.dateFormat(
          new Date(this.create_time[1])
        ).full;
      } else if (num == 2) {
        this.check_audit_time_s = utils.dateFormat(
          new Date(this.check_audit_time[0])
        ).full;
        this.check_audit_time_e = utils.dateFormat(
          new Date(this.check_audit_time[1])
        ).full;
      }
    },
    compTime(beginTime, endTime, type) {
      var str = "";
      var beginTimes = beginTime.substring(0, 10).split("-");
      var endTimes = endTime.substring(0, 10).split("-");

      beginTime =
        beginTimes[1] +
        "-" +
        beginTimes[2] +
        "-" +
        beginTimes[0] +
        " " +
        beginTime.substring(10, 19);
      endTime =
        endTimes[1] +
        "-" +
        endTimes[2] +
        "-" +
        endTimes[0] +
        " " +
        endTime.substring(10, 19);
      var a = (Date.parse(endTime) - Date.parse(beginTime)) / 3600 / 1000;
      if (a < 0) {
        if (type == 1) {
          this.$message({
            message: "提交结束日期不能小于开始日期",
            type: "warning"
          });
          str = 1;
        } else if (type == 2) {
          this.$message({
            message: "发布结束日期不能小于开始日期",
            type: "warning"
          });
          str = 2;
        }
      }
      return str;
    }
  }
};
</script>
<style  scoped>
.goods-img {
  width: 65px;
  height: 65px;
}
.youhuiquan {
  width: 58px;
  height: 22px;
  background: url(../../../src/assets/goods/youhuiquan.png) no-repeat;
  background-size: 58px 22px;
}
.goods-icon {
  display: inline-block;
  width: 16px;
  height: 16px;
  background: url(../../../src/assets/goods/wenhao.png) no-repeat;
  background-size: contain;
}
.min-h40 {
  min-height: 40px;
}
.min-w1096 {
  min-width: 1096px;
}
</style>